// extracted by mini-css-extract-plugin
export default {"card":"Login_card__TonDe","submitBtnContainer":"Login_submitBtnContainer__Ux4q1","loginTableContainer":"Login_loginTableContainer__5wdbC"};